// This function allow to reference chunks
__webpack_require__.k = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "chunk." + {"757": "8f13ce7dd946ed6b","804": "3faaf42b734c399f",}[chunkId] + ".css"
}